module.exports = __webpack_public_path__ + "img/arrow_01_feature1.3cd885b4.svg";